import request from "@/utils/request";

export function getAll() {
  return request({
    url: "/crm/company/getAll",
    method: "get",
  });
}

export function getPage(condition, pagination) {
  return request({
    url: "/crm/company/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

export function saveOrUpdate(data) {
  return request({
    url: "/crm/company/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/crm/company/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/crm/company/deleteById",
    method: "post",
    data: { id: id },
  });
}

export function deleteBatchByIds(ids) {
  return request({
    url: "/crm/company/deleteBatchById",
    method: "post",
    data: { ids: ids },
  });
}

export function exportExcel(condition, pagination) {
  return request({
    url: "/crm/company/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}

export function getByCompanyInfoAdmin(data) {
  return request({
    url: "/crm/company/getByCompanyInfoAdmin",
    method: "post",
    data,
  });
}

export function doIsEnable(data) {
  return request({
    url: "/crm/company/doIsEnable",
    method: "post",
    data,
  });
}

export function doTacitlyApprove(data) {
  return request({
    url: "/crm/company/doTacitlyApprove",
    method: "post",
    data,
  });
}
